export default __webpack_public_path__ + "static/media/banner-finder-medication-desk.257e6aa8.svg";